import { render, staticRenderFns } from "./PracticeFeeEditPayers.vue?vue&type=template&id=616a0b7b&scoped=true&"
import script from "./PracticeFeeEditPayers.vue?vue&type=script&lang=js&"
export * from "./PracticeFeeEditPayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a0b7b",
  null
  
)

export default component.exports